import {
  paths,
  playgroundSessionResponseSchema,
  type PlaygroundSessionResponse,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/**
 * 开一个 Playground 会话。带 uid 是为同一段对话续签令牌，不带才是开新的
 * New test 额外携带 reset_uid，由 BFF 作废旧访客再签发匿名新会话。
 */
export const startPlaygroundSessionOperation = "playground.session";

export type StartPlaygroundSessionOperation =
  typeof startPlaygroundSessionOperation;

export type StartPlaygroundSessionFailure =
  BackendFailure<StartPlaygroundSessionOperation>;

export function startPlaygroundSession(
  options: {
    fetch?: typeof globalThis.fetch;
    signal?: AbortSignal;
    uid?: string;
    resetUid?: string;
  } = {},
): ResultAsync<PlaygroundSessionResponse, StartPlaygroundSessionFailure> {
  return requestBackendResult({
    body: {
      uid: options.uid,
      reset_uid: options.resetUid,
    },
    fetch: options.fetch,
    method: "POST",
    operation: startPlaygroundSessionOperation,
    parse: (payload) => playgroundSessionResponseSchema.parse(payload),
    path: paths.playgroundSessions,
    signal: options.signal,
  });
}
